import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
export default {
  computed: {
    formDefinition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  created() {
    this.$store.dispatch('returnReasonCategory/getItems');
  },
  mixins: [baseCrudMixin],
  watch: {
    formDefinition(definition) {
      this.definition = definition;
    }
  },
  data: () => ({
    entity: 'ReturnReason',
    returnTo: 'ReturnReasons',
    definition: {}
  }),
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
